var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDislikeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7927 72C37.3151 72 36.3731 70.0169 36.5649 66.175C36.6922 63.6424 37.5452 56.5817 33.9707 53.0039C30.637 49.6685 29.6674 49.9647 25.8689 45.6593C22.0704 41.3539 18.907 42.2395 14.4764 42.6202C8.91052 43.0975 10.8067 12.1966 14.7295 12.7323C17.514 13.113 23.8438 13.8727 24.8564 13.8727C25.8689 13.8727 32.8124 8.48826 38.906 8.4238C48.7782 8.32096 54.2228 10.0708 54.2228 10.0708L57.1162 16.6356L58.0842 36.657L53.4634 46.2901C53.4634 46.2901 47.2609 45.2771 45.489 48.063C43.717 50.8488 46.882 54.2686 46.882 62.2471C46.882 70.2256 41.0584 72 39.7927 72Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.568 10.1304L54.1922 11.501C53.0799 11.6192 51.6486 11.1127 49.6941 11.1281C40.3589 11.2002 31.4348 13.8817 27.6056 16.9147C25.0973 18.9009 23.9973 21.544 22.2253 20.7842C20.0392 19.8464 13.8367 18.3882 11.5554 21.2769C12.1936 16.3345 13.332 12.5402 14.7296 12.7305C17.514 13.1112 23.8439 13.871 24.8564 13.871C25.8689 13.871 32.6191 8.63076 38.9076 8.42508C47.0431 8.15954 54.2689 9.56092 54.2689 9.56092L54.568 10.1304Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4298 40.6677C22.101 39.6546 24.4329 41.3307 26.3091 43.6116C28.1731 45.8772 29.7901 47.8864 34.4738 50.9255C39.1575 53.9646 38.5562 62.3238 38.1757 65.1096C37.7952 67.8955 38.0484 71.9999 39.7927 71.9999C37.315 71.9999 36.3731 70.0167 36.5648 66.1749C36.6922 63.6423 37.5452 56.5816 33.9706 53.0038C30.6369 49.6684 29.6674 49.9646 25.8688 45.6592C22.0718 41.3538 18.9069 42.2394 14.4763 42.6201C14.4763 41.6561 14.7586 41.6807 18.4298 40.6677Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4889 48.0643C43.7169 50.8502 46.8818 54.27 46.8818 62.2485C46.8818 70.227 41.0598 71.9998 39.7926 71.9998C39.4597 71.9998 39.1636 71.963 38.8982 71.8924C44.0621 71.5685 47.1718 65.0528 45.3922 58.3344C43.9486 52.8824 43.2291 48.5125 45.587 45.9477C47.112 44.2884 50.145 44.5709 53.4648 46.2915C53.4633 46.2915 47.2608 45.2769 45.4889 48.0643Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8372 45.2201C42.7996 44.207 35.1274 41.8233 29.3161 36.5509C14.5884 23.1894 39.7329 21.5148 44.9259 10.0889C45.9185 7.90475 51.7206 21.544 51.7206 21.544L53.5969 24.7029L48.1752 39.1464L45.8372 45.2201Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2822 44.0643C43.2446 43.0512 30.835 35.0973 30.835 31.1695C30.835 19.8341 39.4292 25.4289 44.0746 12.0536C44.7174 10.201 46.9894 8.64307 46.9894 8.64307C48.8718 10.1795 51.7207 21.544 51.7207 21.544L53.597 24.7029L48.1753 39.1464L46.2822 44.0643Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2947 9.32175L59.1091 15.9725L60.3901 43.7545L45.8357 45.2219C42.4944 43.423 42.1078 40.9625 43.3489 37.0116C43.8705 35.3493 41.7488 34.8735 41.6122 30.0308C41.5171 26.6755 43.714 26.6586 43.714 25.6609C43.714 24.6632 42.6202 24.7523 42.2566 21.862C41.738 17.7269 45.199 17.6471 45.199 16.763C45.199 15.8789 43.2768 15.354 43.3949 11.9833C43.5452 7.70856 35.6107 8.57271 30.2458 12.4622C28.0428 14.06 26.1205 14.2243 24.6201 13.862C24.7137 13.8666 24.7935 13.8697 24.8533 13.8697C25.8658 13.8697 32.6667 8.42383 38.9045 8.42383C46.1978 8.42383 51.2435 8.85207 53.2947 9.32175Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.631 43.3892C50.1375 43.3892 47.6691 38.9963 49.3781 35.621C51.0871 32.2457 46.2132 27.7776 46.7195 25.578C47.2257 23.38 48.1125 17.8114 48.8074 16.8904C49.5024 15.9695 47.6676 13.8804 47.6676 13.8804L53.3638 13.1836L58.6796 15.5289L58.4894 31.6103L59.0585 41.6778L54.631 43.3892Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.869 45.6578C23.4021 42.8612 21.2021 42.2549 18.749 42.278C19.4563 41.136 19.9487 39.8881 19.8981 38.6678C19.7646 35.4691 20.4688 31.5259 21.0073 35.6272C21.4169 38.7507 23.534 42.611 26.0807 45.8957C26.0101 45.8175 25.9411 45.7407 25.869 45.6578Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.035 46.4175C52.7223 46.6201 43.1708 46.921 42.9575 41.3523C42.8041 37.3139 45.6668 35.9893 50.0943 35.8205C54.5219 35.6516 56.7356 35.5672 58.5689 35.4981C60.4038 35.4275 66.1706 35.4628 66.2273 40.3393C66.2979 46.4313 58.035 46.4175 58.035 46.4175Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2966 26.2855C47.873 26.3269 43.6433 25.2601 43.2475 22.5725C42.9361 20.4589 44.0146 17.7283 47.695 17.0836C52.3572 16.2671 60.1261 15.8388 63.0287 16.9256C64.3251 17.4106 65.4557 18.769 65.5155 20.8273C65.5754 22.8856 64.0474 25.6592 60.726 25.7559C57.4046 25.8511 55.674 25.8004 53.7809 26.0245C51.5043 26.2931 50.4365 26.2532 49.2966 26.2855Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8148 16.8933C46.2009 16.8933 44.2065 15.4689 44.2065 13.0944C44.2065 10.7199 44.8233 8.96239 48.2889 8.29777C51.7545 7.63316 57.3081 8.20261 59.396 8.86723C61.0237 9.38603 61.6267 10.9087 61.6267 13.4259C61.6267 15.9432 60.0603 16.3822 58.3513 16.3822C56.6422 16.3822 54.5681 16.0706 53.3837 16.132C50.0777 16.3085 49.4287 16.8933 47.8148 16.8933Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5827 45.2918C52.9434 45.4683 44.6023 45.737 44.4351 41.3348C44.3139 38.1422 46.8176 37.0862 50.6837 36.9388C54.5497 36.7915 64.721 36.6057 64.7548 40.4599C64.7977 45.2765 57.5827 45.2918 57.5827 45.2918Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7246 25.1515C48.4851 25.1868 45.0149 24.8921 44.6819 22.3242C44.4564 20.5866 45.357 18.3549 48.5618 17.8223C52.6226 17.1469 59.3851 16.7847 61.9118 17.6703C63.0394 18.0663 64.0228 19.1761 64.0703 20.8629C64.1194 22.5498 62.5654 24.6173 59.675 24.7018C56.7832 24.7846 55.246 24.5176 53.5968 24.7048C51.6162 24.9258 50.7157 25.1223 49.7246 25.1515Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5035 16.0272C47.1074 16.0272 45.3831 14.8807 45.3831 12.9682C45.3831 11.0557 45.9169 9.64047 48.9146 9.10632C51.9123 8.57217 56.7157 9.02957 58.5229 9.56526C59.9297 9.98276 60.4529 11.2092 60.4529 13.2368C60.4529 15.2629 59.0982 15.6174 57.6193 15.6174C56.1404 15.6174 54.347 15.3657 53.3222 15.4164C50.4611 15.556 49.8996 16.0272 48.5035 16.0272Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6535 41.3342C47.7686 44.3672 50.1864 45.8207 53.2409 46.4899C48.3654 46.3764 43.1156 45.4646 42.9575 41.3526C42.8041 37.3142 45.6668 35.9896 50.0943 35.8207C50.5822 35.8023 51.0409 35.7839 51.4766 35.7686C48.9898 36.4961 47.5323 38.1354 47.6535 41.3342Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0692 45.94C45.2326 45.3199 43.0572 43.9784 42.9575 41.3522C42.8302 37.9953 44.7893 36.5141 47.9971 36.0122C41.4893 38.6123 43.8243 45.0129 48.0692 45.94Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.646 15.7502C35.1413 13.939 31.6189 13.3388 27.7805 14.4102C23.9421 15.4816 21.2405 17.8177 21.7452 19.6289C22.2499 21.4401 25.7723 22.0403 29.6107 20.9689C33.4491 19.8975 36.1508 17.5629 35.646 15.7502Z",
    fill: "url(#paint17_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0147 40.5187C61.9779 38.1887 58.8636 37.0835 55.4563 36.8763C52.6703 36.7075 49.5775 38.6798 49.6573 40.9561C49.737 43.2324 50.1421 45.2493 55.9319 45.0482C59.3438 44.93 62.05 42.7965 62.0147 40.5187Z",
    fill: "url(#paint18_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6344 20.0369C62.616 16.8105 59.069 17.429 55.6617 17.2049C51.3416 16.9194 48.4774 18.2656 48.4758 20.5434C48.4728 22.8212 50.1158 24.4804 55.9103 24.4896C59.3222 24.4958 62.6589 24.1827 62.6344 20.0369Z",
    fill: "url(#paint19_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.511 11.9035C59.4941 9.15291 56.2725 8.77839 53.2195 8.77686C50.1666 8.77379 46.8529 10.3931 46.8513 12.3348C46.8498 14.2765 48.318 15.6917 53.4987 15.6993C56.5501 15.7039 59.5325 15.4369 59.511 11.9035Z",
    fill: "url(#paint20_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2088 21.9202C47.6936 25.5933 50.5102 25.3784 53.7396 25.7591C50.0224 26.0369 48.4622 26.0768 48.4622 26.0768C48.1154 26.1106 47.7273 26.1121 47.3238 26.0707C46.1165 25.8051 44.748 25.2556 43.9349 24.2242C43.6588 23.8312 43.4348 23.3677 43.2875 22.8182C43.2722 22.7384 43.2568 22.657 43.2476 22.5741C42.9853 20.4529 44.0147 17.7299 47.6951 17.0853C48.2259 16.9916 48.7997 16.9041 49.398 16.8228C49.6849 16.7859 49.9978 16.7476 50.3338 16.7046C50.4243 16.6939 50.5148 16.6831 50.6069 16.6724C48.5772 17.6317 46.8528 19.2203 47.2088 21.9202Z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1093 26.0998C47.8592 26.1074 47.5938 26.0982 47.3223 26.0706C46.1042 25.802 44.7234 25.2448 43.915 24.1965C43.648 23.8097 43.4332 23.3523 43.289 22.8166C43.2737 22.7368 43.2629 22.657 43.2491 22.5741C42.8763 20.485 43.9104 18.023 47.1259 17.208C41.6398 20.2349 43.9794 26.0967 48.1093 26.0998Z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3019 16.3336C49.6804 16.5715 49.0145 16.8954 47.8148 16.8954C46.2009 16.8954 44.2065 15.471 44.2065 13.0965C44.2065 12.2338 44.2894 11.4541 44.5579 10.7772C44.8309 10.2185 45.2283 9.6951 45.7729 9.25304C46.3712 8.83554 47.1843 8.51168 48.2874 8.29986C49.0283 8.15711 49.866 8.07269 50.7435 8.03125C49.0498 9.01513 46.181 9.54468 46.7824 12.8386C47.4482 16.4764 49.619 15.9852 51.3019 16.3336Z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7427 16.8919C46.1426 16.8505 44.2065 15.4338 44.2065 13.0946C44.2065 10.9196 44.7266 9.26188 47.4789 8.48828C43.1817 11.2511 44.5609 15.9127 47.7427 16.8919Z",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2275 40.3396C66.2336 40.886 66.1722 41.3818 66.0572 41.8346C66.4852 39.9313 64.79 38.0403 60.2965 37.1224C57.3187 36.5146 49.4103 35.7548 43.938 37.9283C45.1193 36.5008 47.2931 35.9298 50.0945 35.8224C54.522 35.6535 56.7358 35.5691 58.5691 35.5C60.4039 35.4279 66.1707 35.4632 66.2275 40.3396Z",
    fill: "url(#paint25_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5156 20.958C65.5094 23.0025 63.9768 25.6625 60.7245 25.7562C57.4031 25.8513 55.6725 25.8007 53.7794 26.0248C51.5043 26.2934 50.435 26.2535 49.2967 26.2857C48.436 26.3103 46.3128 26.0509 44.8691 25.1529C46.4923 24.5896 49.1371 23.7423 52.8589 23.9803C61.7769 24.5543 64.3143 23.4753 65.5156 20.958Z",
    fill: "url(#paint26_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3852 35.4995C45.4874 35.5379 42.4729 34.4204 42.3946 30.4772C42.3164 26.534 45.7636 25.5962 47.2824 25.5655C48.8012 25.5348 54.1108 25.1726 60.6601 25.0421C67.2093 24.9116 68.0868 28.4281 68.1237 30.27C68.1605 32.1135 66.993 35.4458 63.0533 35.5256C51.6624 35.7543 47.3852 35.4995 47.3852 35.4995Z",
    fill: "url(#paint27_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4039 34.3559C46.7532 34.3881 44.1359 33.5316 44.0761 30.4909C44.0162 27.4503 47.014 26.7181 48.3333 26.692C49.6542 26.6659 54.2704 26.3758 59.9636 26.2622C65.6568 26.1487 66.4131 28.8593 66.4407 30.2822C66.4684 31.7035 66.2735 34.276 62.8478 34.3451C52.9465 34.5416 48.4039 34.3559 48.4039 34.3559Z",
    fill: "url(#paint28_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4678 30.858C46.658 34.9056 49.4823 34.9164 52.6703 35.6163C48.9423 35.5933 47.3852 35.5012 47.3852 35.5012C45.4874 35.5395 42.4729 34.4221 42.3946 30.4789C42.3164 26.5357 45.7636 25.5979 47.2824 25.5672C47.8301 25.5565 48.8717 25.5027 50.2832 25.4321C48.1783 26.2994 46.3281 27.8803 46.4678 30.858Z",
    fill: "url(#paint29_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.787 30.439C64.9189 27.2157 61.3398 26.6094 57.9294 26.4467C54.519 26.284 50.7282 28.0077 50.6192 30.2824C50.5103 32.5572 52.0736 34.2916 57.8604 34.5725C61.2723 34.7368 64.6183 34.5802 64.787 30.439Z",
    fill: "url(#paint30_radial)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0291 35.4936C45.1329 35.3923 42.4666 34.1828 42.3929 30.479C42.3178 26.7308 45.429 25.6978 47.0414 25.5796C40.802 28.0984 42.847 35.1222 47.0291 35.4936Z",
    fill: "url(#paint31_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.113 30.6695C67.2907 24.8368 51.8772 25.9051 43.5483 27.1576C44.6729 25.9527 46.3451 25.5874 47.2824 25.5675C48.8012 25.5368 54.1109 25.1745 60.6601 25.0441C67.2094 24.9136 68.0869 28.4301 68.1237 30.272C68.1252 30.3978 68.1222 30.5314 68.113 30.6695Z",
    fill: "url(#paint32_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3917 17.6807C57.4062 17.5487 49.507 16.5664 43.7478 19.6531C44.3906 18.4589 45.6348 17.4444 47.6951 17.0836C52.3574 16.2671 60.1263 15.8388 63.0288 16.9256C64.3252 17.4106 65.4559 18.769 65.5157 20.8273C65.3239 19.0376 63.6195 17.8235 60.3917 17.6807Z",
    fill: "url(#paint33_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3979 11.1988C59.4418 9.70997 56.0606 8.83046 51.182 9.65471C48.169 10.1643 46.104 10.3377 44.7463 10.3746C45.2894 9.39224 46.3372 8.67083 48.2887 8.29631C51.7543 7.63169 57.3079 8.20114 59.3958 8.86576C60.4682 9.20958 61.0941 9.98932 61.3979 11.1988Z",
    fill: "url(#paint34_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8477 15.2312C48.4621 16.5482 50.234 14.5942 54.1016 14.5942C58.1179 14.5942 60.0325 16.2166 61.4593 14.6741C61.0113 16.0969 59.7288 16.3839 58.3527 16.3839C56.6436 16.3839 54.5695 16.0724 53.3836 16.1338C50.076 16.3072 49.4286 16.8935 47.8147 16.8935C46.7699 16.8935 45.5672 16.2965 44.8477 15.2312Z",
    fill: "url(#paint35_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7295 12.7305C17.514 13.1112 23.8438 13.871 24.8563 13.871C15.6761 20.4358 19.7584 34.3989 23.1458 41.461C23.6214 42.4526 23.9144 43.2661 24.0724 43.9568C21.0179 41.6268 18.1921 42.2991 14.4764 42.6184C8.91052 43.0957 10.8067 12.1948 14.7295 12.7305Z",
    fill: "url(#paint36_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8563 13.8695C24.0692 14.5402 23.1196 15.6699 22.2651 16.7613C22.2651 16.7613 17.6565 14.4021 12.7151 15.5118C13.2843 13.7068 13.9685 12.6262 14.7294 12.7306C17.5139 13.1097 23.8437 13.8695 24.8563 13.8695Z",
    fill: "url(#paint37_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7459 60.3856C40.9417 59.9957 39.4797 62.4884 38.6543 65.397C37.9793 67.7762 38.8967 70.8045 40.6687 71.1468C42.4406 71.4891 44.076 71.5045 45.0532 66.4623C45.627 63.4907 44.5086 60.7662 42.7459 60.3856Z",
    fill: "url(#paint38_radial)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4634 46.2921C53.4634 46.2921 47.2608 45.2791 45.4889 48.0649C43.717 50.8508 46.8819 54.2706 46.8819 62.2491C46.8819 70.2276 41.0583 72.0004 39.7926 72.0004C37.315 72.0004 36.3731 70.0173 36.5648 66.1754C36.6922 63.6428 37.5451 56.5822 33.9706 53.0043C30.6369 49.6689 29.6673 49.9652 25.8688 45.6597C22.0703 41.3543 49.4102 44.4594 53.4634 46.2921Z",
    fill: "url(#paint39_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7425 16.8919C46.7408 16.9119 45.7374 16.4468 45.0425 15.6916C44.326 14.9426 44.0023 13.862 44.0453 12.8459C44.0775 11.8528 44.2278 10.7722 44.8783 9.94031C45.5196 9.10071 46.5214 8.7047 47.4802 8.48828C46.5521 8.82289 45.6331 9.29718 45.0839 10.0923C44.5301 10.8812 44.3843 11.8789 44.3782 12.852C44.3153 13.8206 44.6083 14.7845 45.2342 15.5228C45.851 16.255 46.75 16.7876 47.7425 16.8919Z",
    fill: "#804B24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1501 25.7253C45.4767 25.5074 44.8032 25.208 44.257 24.7199C43.6848 24.2487 43.3381 23.5503 43.1432 22.8535L43.1402 22.8427C43.019 22.215 42.9591 21.5427 43.0895 20.8995C43.2184 20.2564 43.4853 19.6425 43.8704 19.1144C44.6498 18.0446 45.8909 17.4445 47.1228 17.2065C45.9246 17.5964 44.8001 18.2641 44.1051 19.2817C43.3948 20.2887 43.1923 21.5764 43.4317 22.7844L43.4286 22.7737C43.6142 23.4368 43.8858 24.0906 44.3936 24.568C44.8937 25.053 45.4966 25.4414 46.1501 25.7253Z",
    fill: "#804B24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0292 35.4936C45.8464 35.4814 44.6283 35.0746 43.7339 34.2335C42.8272 33.4 42.3578 32.1752 42.2596 30.9748C42.1599 29.7807 42.3578 28.4852 43.1064 27.4983C43.8397 26.5021 44.9919 25.9296 46.1532 25.7178C45.021 26.0493 43.9625 26.6909 43.3151 27.6472C42.6584 28.5988 42.4728 29.7991 42.5909 30.9472C42.6615 32.0999 43.1003 33.2312 43.9118 34.0524C44.7203 34.872 45.8556 35.3601 47.0292 35.4936Z",
    fill: "#804B24"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0694 45.94C46.7884 45.7144 45.489 45.326 44.4181 44.5049C43.3274 43.7036 42.7229 42.3007 42.792 40.9608C42.795 39.6407 43.2491 38.2163 44.3215 37.3568C45.3693 36.4865 46.7086 36.1626 47.9957 36.0122C46.727 36.2824 45.4414 36.6968 44.4887 37.5502C43.5207 38.3944 43.1065 39.6929 43.1218 40.9654C43.0374 42.247 43.579 43.498 44.5762 44.3084C45.5672 45.1219 46.8145 45.5977 48.0694 45.94Z",
    fill: "#804B24"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7478 19.6531C44.1267 18.8948 44.7296 18.244 45.4599 17.7897C46.1948 17.3415 47.0339 17.0821 47.8746 16.9439C49.5468 16.6477 51.2313 16.4343 52.9235 16.2885C54.6172 16.178 56.3155 16.1304 58.0122 16.1734C59.6998 16.2333 61.4318 16.3284 63.0288 16.9286C62.2219 16.663 61.375 16.5771 60.5359 16.5095C59.6967 16.4267 58.8514 16.4052 58.0076 16.3944C56.3185 16.3883 54.6294 16.4758 52.9465 16.6185C51.2605 16.726 49.5791 16.9025 47.9099 17.1604C46.2715 17.3829 44.6115 18.1565 43.7478 19.6531Z",
    fill: "#804B24"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5483 27.1557C44.1559 26.4726 44.9766 25.9891 45.8541 25.7128C46.7424 25.4227 47.6844 25.4657 48.5834 25.4043L54.0403 25.1342L59.5003 24.9761C61.3029 24.8763 63.2037 24.9346 64.8928 25.656C63.1577 25.0605 61.3152 25.0866 59.5049 25.1971L54.048 25.4657L48.588 25.6238C47.6752 25.6653 46.7654 25.6085 45.9002 25.8679C45.0272 26.0874 44.1942 26.511 43.5483 27.1557Z",
    fill: "#804B24"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0535 35.5273C60.4439 35.6701 57.8313 35.7192 55.2187 35.7484C52.6045 35.7898 49.9934 35.7883 47.3777 35.6302H47.3884C46.0368 35.6271 44.6638 35.1405 43.7126 34.1643C43.2355 33.6839 42.8842 33.0868 42.6786 32.4483C42.4761 31.8082 42.404 31.1406 42.3948 30.479C42.4546 31.799 42.8995 33.1237 43.843 34.0339C44.7681 34.9517 46.0997 35.3907 47.3823 35.3708H47.393C48.6924 35.4214 49.9995 35.4291 51.3035 35.4383L55.2187 35.492L59.1353 35.4997C60.4409 35.4859 61.7464 35.5227 63.0535 35.5273Z",
    fill: "#804B24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 53.6682,
    y1: 40.7376,
    x2: 34.6259,
    y2: 39.9734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 34.4681,
    y1: 30.8216,
    x2: 33.1376,
    y2: 16.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.6733,
    y1: 52.0289,
    x2: 45.0184,
    y2: 31.5192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.2921,
    y1: 60.2004,
    x2: 57.0324,
    y2: 57.4488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.5928,
    y1: 27.5346,
    x2: 67.839,
    y2: 27.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 11.8135,
    y1: 27.462,
    x2: 107.129,
    y2: 24.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 26.9583,
    y1: 15.0065,
    x2: 42.7212,
    y2: 23.5484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 45.0154,
    y1: 27.1342,
    x2: 58.1597,
    y2: 28.8604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 21.6872,
    y1: 56.1527,
    x2: 24.5382,
    y2: 8.94598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 65.3275,
    y1: 40.9925,
    x2: 46.6754,
    y2: 40.9924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 65.3275,
    y1: 21.28,
    x2: 46.6652,
    y2: 21.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 65.3278,
    y1: 12.4459,
    x2: 46.6758,
    y2: 12.4458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 44.1611,
    y1: 40.8994,
    x2: 53.8761,
    y2: 41.1209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 61.1504,
    y1: 21.1482,
    x2: 51.2474,
    y2: 21.1481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 61.1505,
    y1: 12.4456,
    x2: 51.2475,
    y2: 12.4455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 49.0618,
    y1: 41.1278,
    x2: 43.7779,
    y2: 41.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 48.1124,
    y1: 40.9756,
    x2: 42.0358,
    y2: 40.9755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0049 18.932) rotate(-15.5933) scale(7.41793 3.44458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8453 40.9465) rotate(-2.02716) scale(6.34702 4.16575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5383 20.494) rotate(0.0544049) scale(6.81628 3.6745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1803 12.2328) rotate(0.0539593) scale(6.24088 3.90599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 49.695,
    y1: 21.3858,
    x2: 42.0368,
    y2: 21.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 48.0673,
    y1: 21.6535,
    x2: 43.9421,
    y2: 21.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 49.4199,
    y1: 12.3962,
    x2: 40.464,
    y2: 14.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 48.4938,
    y1: 12.6885,
    x2: 44.7083,
    y2: 12.6885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 54.5279,
    y1: 42.1672,
    x2: 56.9353,
    y2: 30.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 56.3569,
    y1: 19.1477,
    x2: 53.7302,
    y2: 28.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 65.3276,
    y1: 30.329,
    x2: 46.6756,
    y2: 30.3289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 45.9232,
    y1: 30.8494,
    x2: 60.211,
    y2: 30.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFCB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7382,
    stopColor: "#FFD748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 51.4987,
    y1: 30.5219,
    x2: 40.8241,
    y2: 30.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FBA23B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6969 30.5013) rotate(2.73604) scale(6.97946 4.5811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 46.5367,
    y1: 30.535,
    x2: 43.1664,
    y2: 30.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 55.4132,
    y1: 31.5627,
    x2: 57.4405,
    y2: 18.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 54.0083,
    y1: 21.5936,
    x2: 59.2025,
    y2: 10.3242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 52.9739,
    y1: 11.7071,
    x2: 53.7341,
    y2: 4.58335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 53.1532,
    y1: 12.7882,
    x2: 53.1532,
    y2: 17.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 17.7506,
    y1: 31.6938,
    x2: 11.0991,
    y2: 51.9708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 18.9082,
    y1: 19.3892,
    x2: 18.528,
    y2: 4.85665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.877 65.7972) rotate(-79.0714) scale(6.69225 3.92587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD748",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 39.2489,
    y1: 43.4792,
    x2: 44.1271,
    y2: 87.5827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDislikeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DislikeIcon.9a69e0a3.svg";
export { ForwardRef as ReactComponent };